import React from "react";
const Page = React.lazy(() => import("./page"));
export default Page;
